import ChargeDialog from './charge-dialog.vue';

export default ChargeDialog;
